type ErrorSetter = (error: string) => void;

export const validateEmail = (email: string, setError: ErrorSetter) => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!email) {
    setError("Email is required");
  } else if (!re.test(email)) {
    setError("Invalid email format");
  } else {
    setError("");
  }
};

export const validatePassword = (password: string, setError: ErrorSetter) => {
  if (!password) {
    setError("Password is required");
  } else if (password.length < 8) {
    setError("Password must be at least 8 characters long");
  } else {
    setError("");
  }
};

export const confirmPasswordMatch = (
  password: string,
  confirmPassword: string,
  setError: ErrorSetter
) => {
  if (password !== confirmPassword) {
    setError("Passwords do not match");
  } else {
    setError("");
  }
};
